export default __webpack_public_path__ + "static/media/TransferH.5c35725a.svg";